/**
 * Route definitions. Entry point to all routes.
 */
import React from 'react';
import { Route } from 'react-router';

import appConfig from '@nerdwallet/app-config';

// eslint-disable-next-line import/extensions -- directive added automatically by Shepherd migration
import Container from './container.jsx';

// This stops data-dependencies from making it to the client.
// It contains logic about monetizing partners that we don't
// want to make public, as well as reduces bundle size by 50kb
// because we don't ship all the actions and fetching logic.
let dataDependencies = [];
if (!process.browser) {
  dataDependencies = require('./data-dependencies').default; // eslint-disable-line
}

const baseUri = appConfig.BASE_URI;

/**
 * Entry point to your app
 */
const routes = (
  <Route
    path={baseUri}
    dataDependencies={dataDependencies}
    render={() => <Container />}
  />
);

export default routes;
